export default "__VITE_PUBLIC_ASSET__0c8f2694__"